import styled from '@emotion/styled';
import { Radio } from '@mui/material';

const RadioWithoutPadding = styled(Radio)({
  paddingTop: 0,
  paddingBottom: 0,
});

export default RadioWithoutPadding;
